import { Base } from "@/atoms-react/text/Text.react";
import { AnimatedShield } from "@/components/animations/shield/index.react";
import { LegalEntityFrontDto } from "@/features/company/types";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/features/router";
import { useTranslation } from "react-i18next";
import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";

export const CompanyCard = (
  props: LegalEntityFrontDto & {
    logoutPrivy: () => Promise<void>;
  }
) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["pass"]);
  const origin = useOrigin();
  const getShield = () => {
    switch (props.legal_entity_olkypass.olkypass_status.level) {
      case 1:
        return (
          <AnimatedShield
            color={"#D11E1F"}
            style="bottom-11 left-6  w-8 h-3"
            percentage={40}
            miniSize="80"
          />
        );
      case 2:
        return (
          <AnimatedShield
            color={"#1D98DF"}
            style="bottom-16 left-5 w-10 h-4"
            percentage={50}
            miniSize="80"
          />
        );
      case 3:
        return (
          <AnimatedShield
            color={"#82C805"}
            percentage={60}
            style="top-16  left-5 w-10 h-4"
            miniSize="80"
          />
        );
      case 4:
        return (
          <AnimatedShield
            color={"#652E10"}
            percentage={70}
            style="top-16  left-5 2xl:w-10 h-4"
            miniSize="80"
          />
        );
      case 5:
        return (
          <AnimatedShield
            color={"#B7B7B7"}
            style="top-16 left-5 2xl:w-10 h-4"
            percentage={70}
            miniSize="80"
          />
        );
      case 6:
        return (
          <AnimatedShield
            color={"#D09A31"}
            style="top-16 2xl:left-5 2xl:w-10 h-4"
            percentage={100}
            miniSize="80"
          />
        );

      default:
        break;
    }
  };
  return (
    <div className="relative flex w-full max-w-[420px] flex-col rounded-sm border-2 border-slate-50 px-5 py-4 lg:min-h-[250px] lg:w-[450px] dark:border-slate-700">
      <div className="mb-5 flex flex-row justify-between">
        <div className="flex max-w-xs flex-col">
          <Base
            className="mb-3 line-clamp-1 w-[300px] truncate font-bold text-xl"
            data-tooltip={props.legal_entity.LegalName}
          >
            {props.legal_entity.LegalName?.toLocaleUpperCase()}
          </Base>
          <div className="flex w-full flex-col">
            <Base className="text-base">{props.legal_entity_home_address.address_1}</Base>
            <div className="nowrap flex flex-row">
              <Base className="text-">{props.legal_entity_home_address.zip_code}</Base>
              <Base className="ml-1 text-base">{props.legal_entity_home_address.city}</Base>
            </div>
            <Base className="mb-3 text-base">{props.legal_entity_home_address.country_id}</Base>
          </div>
          <div className="mt-4 flex w-full flex-row justify-end">
            <Base className="text-sm">
              {t("business.input.number_registration")}: {props.legal_entity.RCSnumber}
            </Base>
          </div>
        </div>
        <div className="">{getShield()}</div>
      </div>
      <div className="absolute right-0 bottom-0 flex w-full flex-row justify-end p-2">
        <Base
          onClick={async () => {
            navigate(
              origin === FromURL.None
                ? `${Routes.dashboard}/${props.legal_entity.UUID}`
                : `${Routes.dashboard}/${props.legal_entity.UUID}/${sessionStorage.getItem(
                    "origin"
                  )}`
            );
            await props.logoutPrivy();
          }}
          className="cursor-pointer text-primary underline"
          dataCy={`mycompanies-edit-olkypaspro-item-${props.legal_entity.LegalName}`}
        >
          {t("business.button.manage_company")}
        </Base>
      </div>
    </div>
  );
};
